// tslint:disable:no-trailing-whitespace
// tslint:disable:member-ordering
import { BaseEntity } from '../base-entity';
import { InvoiceHeader } from './invoice-header';
import { ItemDetail } from './item-detail';

/// <code-import> Place custom imports between <code-import> tags
import _ from 'lodash';
/// </code-import>

/// <module-code> Place module level code between <module-code> tags

/// </module-code>

export class ShipBin extends BaseEntity  {

  /// <code> Place custom code between <code> tags
  // assumes invoiceHeaders and associated joHeaders are fetched.
  get firstJoh() {
    const invh = _.first(this.invoiceHeaders);
    return invh.joHeader;
  }
  /// </code>

  // Generated code. Do not place code below this line.
  /** Int32 key */
  id!: number;
  /** String(50) */
  aggregateGroupingKey!: string;
  /** DateTime */
  expectedShipDate!: Date;
  /** Boolean */
  isBinFull!: boolean;
  /** Boolean */
  isOpen!: boolean;
  /** Int32 */
  priorityOrder!: number;
  /** Int32 */
  shipFrequencyId!: number;
  /** Inv FK shipBinId */
  invoiceHeaders!: InvoiceHeader[];
  /** Inv FK shipBinId */
  itemDetails!: ItemDetail[];
}

